import React, { Children } from 'react';
import { ArrowLeftIcon, GlobeIcon, MenuIcon } from 'lucide-react';
interface AppHeaderProps {
  title: string;
  showBack: boolean;
  onBack: () => void;
  lang: string;
  onToggleLang: () => void;
  children?: React.ReactNode;
}
export function AppHeader({
  title,
  showBack,
  onBack,
  lang,
  onToggleLang,
  children
}: AppHeaderProps) {
  return <div className="w-full flex flex-col flex-shrink-0" data-id="element-1839">
      {/* Dark Header Bar */}
      <div className="bg-[#1C1C1E] w-full py-2.5 pt-[calc(0.625rem+1.75rem)] -mt-7 px-4 flex items-center shadow-sm z-20 relative" data-id="element-1840">
        {/* Left: Back Button */}
        <div className="flex items-center w-20" data-id="element-1841">
          {showBack ? <button onClick={onBack} className="text-white hover:bg-gray-800 p-1.5 rounded-full transition-colors -ml-1.5" data-id="element-1842">
              <ArrowLeftIcon className="w-5 h-5" data-id="element-1843" />
            </button> : <div className="w-8" data-id="element-1844" />}
        </div>

        {/* Center: Title */}
        <span className="flex-1 text-white font-semibold text-sm tracking-wide text-center" data-id="element-1845">
          {title}
        </span>

        {/* Right: Lang, Hamburger */}
        <div className="flex items-center gap-3 w-20 justify-end" data-id="element-1846">
          {/* Language Picker */}
          <button onClick={onToggleLang} className="flex items-center gap-1.5 px-2 py-1 rounded-md bg-gray-800 text-gray-200 text-xs font-semibold hover:bg-gray-700 transition-colors border border-gray-700" data-id="element-1847">
            <GlobeIcon className="w-3.5 h-3.5" data-id="element-1848" />
            {lang.toUpperCase()}
          </button>

          {/* Hamburger Menu */}
          <button className="text-white hover:bg-gray-800 p-1.5 rounded-full transition-colors -mr-1.5" data-id="element-1849">
            <MenuIcon className="w-5 h-5" data-id="element-1850" />
          </button>
        </div>
      </div>

      {/* Optional Children (e.g. StepIndicator) */}
      {children && <div className="w-full bg-gray-50 z-10 relative" data-id="element-1851">{children}</div>}
    </div>;
}